/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  const social = data.site.siteMetadata?.social

  return (
    <div className="flex mb-16 space-x-4">
      <StaticImage
        className="rounded-full flex-shrink-0"
        layout="fixed"
        formats={["auto", "webp", "avif"]}
        src="../images/profile.png"
        width={50}
        height={50}
        quality={95}
        alt="Profile picture"
      />
      <div>
        {author?.name && (
          <p className="break-words">
            Written by <strong>{author.name}</strong> {author?.summary || null}
          </p>
        )}
        <a
          href={`https://twitter.com/${social?.twitter || ``}`}
          className="text-green-500 underline"
        >
          @s-spica
        </a>
      </div>
    </div>
  )
}

export default Bio
